import { render, staticRenderFns } from "./DialogSlot.vue?vue&type=template&id=020bffba&scoped=true"
import script from "./DialogSlot.vue?vue&type=script&lang=js"
export * from "./DialogSlot.vue?vue&type=script&lang=js"
import style0 from "./DialogSlot.vue?vue&type=style&index=0&id=020bffba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020bffba",
  null
  
)

export default component.exports